import type { Animation } from "@blings/blings-player";
import type { Precomposition } from "@blings/blings-player/lib/src/libs/l/types/assets";

function hasLayers(asset: any): asset is Precomposition {
  return Array.isArray(asset?.layers);
}

function getAssetDisplayName(asset: Precomposition): string {
  return asset.nm || asset.id || "";
}

export function getAssetDisplayNameOccurrences(assets: any[]) {
  return assets.reduce<Record<string, number>>((acc, asset) => {
    if (!hasLayers(asset)) return acc;
    const displayName = getAssetDisplayName(asset);
    if (!displayName) return acc;
    acc[displayName] = (acc[displayName] || 0) + 1;
    return acc;
  }, {});
}

export function getAssetLayerPairKey(
  asset: Precomposition,
  nameOccurrences: Record<string, number>
): string {
  const displayName = getAssetDisplayName(asset);
  if (!displayName) return "";
  const hasDuplicateName = nameOccurrences[displayName] > 1;
  return hasDuplicateName ? asset?.id || displayName : displayName;
}

export function getAssetLayerPairs(jsonFile: Animation) {
  const assets = jsonFile.assets ?? [];
  const nameOccurrences = getAssetDisplayNameOccurrences(assets);

  const assetPairs = assets
    .map((a) => {
      if (!hasLayers(a)) return [];
      const key = getAssetLayerPairKey(a, nameOccurrences);
      if (!key) return [];
      return [key, a.layers.map((l) => ({ uid: l?.uid, nm: l.nm }))] as const;
    })
    .filter((x) => x.length);

  const mainPairs = jsonFile.layers.map((l) => ({ uid: l?.uid, nm: l.nm }));
  const assetLayerPairs = {};
  for (let p of assetPairs) {
    assetLayerPairs[p[0]] = p[1];
  }
  return [assetLayerPairs, mainPairs];
}
